export enum VocabularyRejectionCode {
  TOO_MANY_TERMS = 'too_many_terms',
  EMPTY_TERM = 'empty_term',
  TERM_TOO_LONG = 'term_too_long',
  PHRASE_TOO_LONG = 'phrase_too_long',
  DUPLICATE_IN_LIST = 'duplicate_in_list',
  DUPLICATE_OF_READ_ONLY = 'duplicate_of_read_only',
}

export interface VocabularyLimits {
  maxTerms: number
  maxWordsPerTerm: number
  maxTermLength: number
}

export interface AccountVocabulary {
  system: string[]
  enterprise: string[]
  account: string[]
  locked: boolean
  effective: string[]
  limits: VocabularyLimits
}

export interface VocabularyRejectedTerm {
  term: string
  code: VocabularyRejectionCode
  index: number
}

export interface AccountVocabularyAddResult extends AccountVocabulary {
  added: string[]
  rejected: VocabularyRejectedTerm[]
}
